import { Container } from '../../../odie';
import { DoorBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';
import { SpineView, spineLoader } from '@play-co/timestep-spine';
import { playSpineAnimation } from 'src/lib/ui/utils/spine';

export const dogHouseSpine = {
  loadMethod: spineLoader,
  url: getMatch2AssetPath('blocks/dogHouse/animation/spine.doghouse'),
};

export class DogHouseBlockView extends Container {
  public spine?: SpineView;
  private _count = 0;

  public get count(): number {
    return this._count;
  }

  public set count(value: number) {
    if (value === this._count) return;
    this._count = value;
    this.playProgressAnimation(value);
  }

  constructor(props: DoorBlockProps) {
    super();
    blockPositionView(this, props);
    this.createSpine(props.color);
  }

  private async createSpine(color: DoorBlockProps['color']) {
    if (this.spine) return;
    await spineLoader(dogHouseSpine.url);
    this.spine = new SpineView({
      superview: this.view,
      spinePath: dogHouseSpine.url,
      scale: 0.62,
      y: 2,
    });
    this.spine.skeleton.setSkinByName(color === 'all' ? 'base' : color);
    playSpineAnimation(this.spine, {
      animation: this.getStateAnimation(this.count),
      loop: false,
    });
  }

  public static assets() {
    return [dogHouseSpine];
  }

  public async playProgressAnimation(count: number) {
    if (!this.spine) return;

    const progressAnim = this.getProgressAnimation(count);

    if (progressAnim) {
      await playSpineAnimation(this.spine, {
        animation: progressAnim,
        loop: false,
      });
    }

    return playSpineAnimation(this.spine, {
      animation: this.getStateAnimation(count),
      loop: false,
    });
  }

  private getStateAnimation(count: number) {
    switch (count) {
      case 2:
        return 'stage1';
      case 1:
        return 'stage2';
      case 0:
      default:
        return 'stage3';
    }
  }

  private getProgressAnimation(count: number) {
    switch (count) {
      case 1:
        return 'stage1-2';
      case 0:
        return 'stage2-3';
      default:
        return undefined;
    }
  }

  public async playPoofAnimation() {
    if (!this.spine) return;
    await playSpineAnimation(this.spine, { animation: 'poof', loop: false });
  }
}
